"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.abortableFetch = void 0;
function abortableFetch(request, opts) {
    const controller = new AbortController();
    const signal = controller.signal;
    const response = fetch(request, { ...opts, signal });
    return {
        abort: () => controller.abort(),
        response,
        raw: async () => {
            const res = await response;
            if (!res.ok) {
                const data = await res.json();
                throw data;
            }
            return res;
        },
        json: async () => {
            const res = await response;
            const data = await res.json();
            if (!res.ok) {
                throw data;
            }
            return data;
        },
        text: async () => {
            const res = await response;
            const data = await res.text();
            if (!res.ok) {
                throw data;
            }
            return data;
        },
        none: async () => {
            const res = await response;
            if (res.status === 403) {
                throw { message: 'Přístup odepřen' };
            }
            else if (!res.ok) {
                throw await res.json();
            }
            return;
        },
    };
}
exports.abortableFetch = abortableFetch;
//# sourceMappingURL=abortable-fetch.js.map